import { AppScriptingAPI } from './AppScriptingAPI';
import { DocScriptingAPI } from './DocScriptingAPI';
import type { ScriptingContext } from './ScriptingContext';

// This is the environment passed to scripts. It provides access to the API
// objects for the app as a whole, and the current document.
export class ScriptingEnv {
  #app: AppScriptingAPI;
  #doc: DocScriptingAPI;

  constructor(context: ScriptingContext) {
    this.#app = new AppScriptingAPI(context);
    this.#doc = new DocScriptingAPI(context);
  }

  get app(): AppScriptingAPI {
    return this.#app;
  }

  get doc(): DocScriptingAPI {
    return this.#doc;
  }
}

// Affords the scripting API being accessed from the browser console.
export function setGlobalScriptingEnv(context: ScriptingContext) {
  const env = new ScriptingEnv(context);
  Object.assign(globalThis, { app: env.app, doc: env.doc });
}
